// extracted by mini-css-extract-plugin
var _1 = "gB5x_FQ5";
export { _1 as "mobileTextContainer" }
